export { AllCommunicationPageDesc } from './AllCommunicationPageDesc';
